import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'

// 店长密码接口要校验"当前登录的是不是这家店的管理员"，必须带 satoken 头；
// hillo 全局没有配置 token，所以这里直接用 fetch。
const base = cloudV2Url + 'membership/shop-manager-password/'

async function request (path, options = {}) {
  const res = await fetch(base + path, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      satoken: localStorage.getItem('token') ?? '',
      ...(options.headers ?? {})
    }
  })
  if (res.status === 401) {
    throw new Error('登录已过期，请重新登录')
  }
  const body = await res.json().catch(() => null)
  if (!body || body.code !== 200) {
    throw new Error(body?.message || `请求失败 (${res.status})`)
  }
  return body.data
}

export function getShopManagerPasswordStatus (shopBlId) {
  return request('status?shopBlId=' + shopBlId)
}

export function changeShopManagerPassword (shopBlId, newPassword, oldPassword) {
  return request('change', {
    method: 'POST',
    body: JSON.stringify({ shopBlId, newPassword, oldPassword: oldPassword || null })
  })
}
